import React from 'react';

export function Footer() {
  return (
    <footer className='mt-auto'>
      <div className='footer'>
        <span className='uppercase'>&copy; 2021 Ubaform Admin App</span>
      </div>
    </footer>
  );
}
